import React from 'react';
import SceneController from './SceneController';
import './index.css';

export default class Home extends React.Component {

    componentDidMount() {
        this.threeRootElement.style.outline = 'none';
        this.sceneController = new SceneController(this.threeRootElement);
        this.addEventListeners();
        this.sceneController.setup();
        this.update();
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
        document.removeEventListener("keydown", this.onDocumentKeyDown);
        if (this.sceneController) this.sceneController.dispose();
    };

    addEventListeners() {
        window.addEventListener('resize', this.onWindowResize, false);
        document.addEventListener("keydown", this.onDocumentKeyDown, false);
    };

    onWindowResize = () => {
        if (this.sceneController) {
            this.sceneController.onWindowResize();
            this.sceneController.update();
        }
    };

    onDocumentKeyDown = (e) => {
        console.log(e.keyCode);
        e.preventDefault();
        if (this.sceneController) this.sceneController.onKeyDown(e);
    };

    update = () => {
        requestAnimationFrame(this.update);
        if (this.sceneController) this.sceneController.update();
    };

    render() {
        return (
            <>
                <div className="customCanvas" ref={element => this.threeRootElement = element}>
                </div>
                <Text />
            </>
        );
    }
};

const Text = () => {
    return (
        <div className="Info">
            Christmas for Rita
            <br />
            CLICK the labels
            <br />one by one
            <br />
            <br />
            Model by <a id="designer" href="https://sketchfab.com/tinyruin">tinyruin</a>
        </div>
    );
}